import script from "./formView.vue?vue&type=script&setup=true&lang=js"
export * from "./formView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__